import React from 'react';
import AverageStarRatingAndTotal, {
  STAR_RATING_SECTION,
} from '../../../../shared/average-star-rating-and-total';
import AgencyAddress from '../agency-address';
import * as styles from './agency-banner.style';
import { HERO_SECTION } from '../../../constants';
import { OverallStarRating } from '../../../../shared/recommendations/types';

export type Props = {
  agencyName: string;
  address: string;
  hideOfficeLocation?: boolean;
  onAgencyAddressClick: () => void;
  onVendorTotalReviewsClick?: () => void;
  overallStarRating?: OverallStarRating;
};

const heroSection = HERO_SECTION.banner;

const AgencyBanner = ({
  agencyName,
  address,
  hideOfficeLocation = false,
  overallStarRating,
  onAgencyAddressClick = () => undefined,
  onVendorTotalReviewsClick = () => undefined,
}: Props): JSX.Element => {
  const showRating = Boolean(overallStarRating?.totalReviews);

  return (
    <div data-testid={`trade-profile-hero-${heroSection}__agency-details-body`}>
      <h1
        css={styles.agencyNameLarge}
        data-testid={`trade-profile-hero-${heroSection}__name`}
      >
        {agencyName}
      </h1>
      {!hideOfficeLocation && (
        <AgencyAddress
          heroSection={heroSection}
          address={address}
          onAgencyAddressClick={onAgencyAddressClick}
        />
      )}
      {showRating && (
        <AverageStarRatingAndTotal
          section={STAR_RATING_SECTION.HERO}
          averageRating={overallStarRating?.rating ?? 0}
          totalReviews={overallStarRating?.totalReviews ?? 0}
          scrollTo
          onVendorTotalReviewsClick={onVendorTotalReviewsClick}
        />
      )}
    </div>
  );
};

export default AgencyBanner;
